<template>
  <div></div>
</template>

<script>
export default {
  name: 'Logout'
}
</script>